import { REPAYMENT_OPTIONS } from '../constants';

/**
 * Get lease term option by value.
 * @param {Array} options - Lease term options (e.g. LEASE_TERM_OPTIONS)
 * @param {number} value - Term value (36, 48, 60)
 * @returns {Object|undefined} Matching option or undefined
 */
export function getLeaseTermByValue(options, value) {
  if (!Array.isArray(options)) return undefined;
  return options.find((opt) => opt.value === value);
}

/**
 * Get default lease term option from options array.
 * @param {Array} options - Lease term options (e.g. LEASE_TERM_OPTIONS)
 * @param {number} defaultTerm - Default term value (e.g. DEFAULT_LEASE_TERM)
 * @returns {Object|undefined} Matching option or undefined
 */
export function getDefaultLeaseTermOption(options, defaultTerm) {
  if (!Array.isArray(options)) return undefined;
  return options.find((option) => option.value === defaultTerm);
}

/**
 * Get lease term option from a route query value.
 * @param {Array} options - Lease term options (e.g. LEASE_TERM_OPTIONS)
 * @param {string|number} queryValue - Route query lease term value
 * @returns {Object|undefined} Matching option or undefined
 */
export function getLeaseTermOptionFromQuery(options, queryValue) {
  if (!Array.isArray(options) || queryValue === undefined || queryValue === null || queryValue === '') return undefined;

  const normalizedValue = typeof queryValue === 'string' ? parseInt(queryValue, 10) : queryValue;

  if (!Number.isInteger(normalizedValue)) return undefined;

  return getLeaseTermByValue(options, normalizedValue);
}

/**
 * Get repayment option from a route query value.
 * @param {string} queryValue - Route query budgetType/repayment value
 * @returns {string|undefined} Matching repayment option or undefined
 */
export function getRepaymentOptionFromQuery(queryValue) {
  if (!REPAYMENT_OPTIONS.includes(queryValue)) return undefined;

  return queryValue;
}
